
export const getCurrentLangKey = (langs: any[], defaultLangKey: any, url: string) => {
    const langKey = url.split('/')[1];
    const langKeyMatch = langs.find((i: string) => i == langKey);
    return langKeyMatch ? langKeyMatch : defaultLangKey
}

export const getHostname = (url) => {
    const matches = url.match(/^(?:https?:)?(?:\/\/)?([^\/\?]+)/i)
    return matches && matches[1]
}

export const ConditionalWrapper = ({ condition, wrapper, children }) => (condition ? wrapper(children) : children)